module.exports = __webpack_public_path__ + "img/hz.a03504c1.png";